import AuthLoginAPI from '@/app/apis/auth/auth-login/auth-login-api.js';

export default {
  /**
   * @param {*} authDetails
   */
   async putAuthLogin(authDetails) {
     return AuthLoginAPI.putAuthLogin(authDetails);
   }
}